export default "__VITE_ASSET__DgaKouvU__"